import { Link } from 'react-router-dom';
import { getFeaturedComics } from '@/mocks/comics';

export default function FeaturedComics() {
  const featured = getFeaturedComics();

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100" aria-labelledby="featured-title">
      <div className="mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <h3 id="featured-title" className="text-xl md:text-2xl font-heading text-foreground-950">
            推荐佳作
          </h3>
          <Link
            to="/category/romance"
            className="flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            更多推荐
            <i className="ri-arrow-right-s-line text-base"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
          {featured.map((comic) => (
            comic && (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className="group cursor-pointer"
              >
                <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    title={`${comic.title} - 香香漫画推荐`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-2 left-2">
                    <span className="px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-medium">
                      {comic.rating}分
                    </span>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-50/90 to-transparent pt-8 pb-2 px-2">
                    <span className="text-xs text-foreground-500">{comic.chapters}话</span>
                  </div>
                </div>
                <h4 className="text-sm md:text-base text-foreground-800 font-medium group-hover:text-primary-500 transition-colors line-clamp-1">
                  {comic.title}
                </h4>
                <p className="text-xs text-foreground-500 mt-1">{comic.category} · {comic.author}</p>
              </Link>
            )
          ))}
        </div>
      </div>
    </section>
  );
}